if (!customElements.get('cabane-product-back')) {
  customElements.define('cabane-product-back', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      if (!link || !document.referrer) return;
      try {
        const previous = new URL(document.referrer);
        // A real link preserves collection filters and avoids variant-history loops.
        if (previous.origin === location.origin && previous.pathname !== location.pathname &&
            /^\/(?:$|collections(?:\/|$)|products\/|search(?:\/|$)|pages\/)/.test(previous.pathname)) {
          link.href = previous.href;
        }
      } catch (_) { /* Keep the collection fallback on a direct visit. */ }
    }
  });
}
